import React from 'react';
import ContentLoader from 'react-content-loader';
import { Icon } from '@reverse-hr/design-system';

const Picto = ({ icon, width }) => {
  return (
    <div className="c-profile-info-list__item">
      <Icon className="c-profile-info-list__icon" name={icon} />
      <ContentLoader viewBox={`0 0 ${width} 20`} width={width} height="20">
        <rect x="0" y="0" rx="2" ry="2" width={width.toString()} height="20" />
      </ContentLoader>
    </div>
  );
};

export default Picto;
